<div
    class="modal-fade-overlay z-50 dark:bg-contrast-black"
    *ngIf="visible"
    [ngClass]="{ 'small-screen-size': isItSmall, 'focus-hidden': !showFocusOutline }">
    <div
        class="modal-dialog-{{ size }} dark:bg-contrast-black"
        [ngClass]="{ 'small-screen-size': isItSmall, 'modal-shadow-status-bar': env.STATUS_BAR }"
        cdkTrapFocus
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-aria-label">
        <button
            class="modal-dialog-{{ size }}__btn-close dark:bg-contrast-black"
            #firstFocus
            (keydown.enter)="closeModal()"
            (keydown.space)="closeModal()"
            (click)="closeModal()"
            tabindex="0"
            attr.aria-label="{{ 'CLOSE_ARIA_LABEL' | translate }}">
            <span class="icon icon-input-delete" *ngIf="visibleCloseIcon"></span>
        </button>
        <div class="modal-dialog-{{ size }}__content">
            <ng-content></ng-content>
        </div>
    </div>
</div>
